import React, { useEffect } from "react";
import Table from "./table/Table";
import { useAuth } from "../store/Auth";
import { useNavigate } from "react-router-dom";

export default function UserCMRRequestsList() {
  const getAuth = useAuth((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      getAuth.authenticated !== true ||
      getAuth.token === "" ||
      !getAuth.token
    ) {
      navigate("/login");
    }
  }, [getAuth, navigate]);

  // Prevent the table from briefly flashing before the redirect happens
  if (!getAuth.authenticated || !getAuth.token) {
    return null;
  }

  return (
    <div>
      <Table />
    </div>
  );
}